/** @jsx jsx */
import React, { useEffect, useState } from "react";
import { jsx, css } from "@emotion/core";

import loading from "../../assets/waiting-dog.png";
import ColoredH1 from "../ColoredHeader";

import { colors } from "../../theme";

const Loading = () => {
    const [delayed, setDelayed] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => setDelayed(false), 800);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <>
            {!delayed && (
                <>
                    <img
                        data-testid="loading-image"
                        css={css`
                            align-self: center;
                            margin-top: 40px;
                            margin-bottom: 40px;
                        `}
                        src={loading}
                        alt="Illustration of a dog chasing its tail"
                    />
                    <ColoredH1 color={colors.neutral8}>Loading...</ColoredH1>
                </>
            )}
        </>
    );
};

export default Loading;
